import { Injectable } from '@angular/core';
import { CreateSectionMessage, CreateSectionReview, SectionIdentifier, SectionMessage, SectionReview } from './review-section.domain';
import { CommunicationService } from 'src/app/services/communication.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { parseIntOrNull } from '../../helpers/parsers.helper';

@Injectable({
  providedIn: 'root',
})
export class ReviewSectionService {
  constructor(private communicationService: CommunicationService) {}

  public getSectionMessages(applicationId: number | string, sections: SectionIdentifier[] = null): Observable<SectionMessage[]> {
    if (!sections || !sections.length) {
      return this.communicationService.getData(`sectionmessage/${applicationId}`).pipe(this.mapMessageResponse());
    }

    return this.communicationService
      .getData(`sectionmessage/${applicationId}?sections=${sections.join(',')}`)
      .pipe(this.mapMessageResponse());
  }

  private mapMessageResponse() {
    return map((messages: SectionMessage[]) =>
      messages.map(m => {
        m.entity_id = parseIntOrNull(m.entity_id);
        return m;
      })
    );
  }

  public createSectionMessage(message: CreateSectionMessage): Observable<SectionMessage> {
    return this.communicationService.postData('sectionmessage', message).pipe(
      map((message: SectionMessage) => {
        message.entity_id = parseIntOrNull(message.entity_id);
        return message;
      })
    );
  }

  public getSectionReviews(applicationId: number | string): Observable<SectionReview[]> {
    return this.communicationService.getData(`sectionreview/${applicationId}`).pipe(
      map((reviews: SectionReview[]) =>
        reviews.map(r => {
          r.id = parseIntOrNull(r.id); // fix id type to be integer
          r.entity_id = r.entity_id ? parseInt(r.entity_id.toString()) : null; // fix id type to be integer
          return r;
        })
      )
    );
  }

  public createSectionReview(review: CreateSectionReview): Observable<SectionReview> {
    return this.communicationService.postData('sectionreview', review).pipe(
      map((r: SectionReview) => {
        r.entity_id = parseIntOrNull(r.entity_id);
        return r;
      })
    );
  }
}
